import { EditAnnouncementList } from './EditAnnouncementList';
export default EditAnnouncementList;
